import { createAction } from "@reduxjs/toolkit";

export const addNotification = createAction("notifications/addNotifications")
export const removeNotifications = createAction("notifications/removeNotifications")
